import { AuthLayout } from '@amore/ui/components/auth-layout'
import { BrandWordmark } from '@amore/ui/components/brand'

// Stub: the screen fork replaces this file (and may add files in this folder).
export function LoginScreen() {
  return (
    <AuthLayout brand={<BrandWordmark />}>
      <h1 className="font-heading text-3xl">Přihlášení</h1>
    </AuthLayout>
  )
}

export function SignupScreen() {
  return (
    <AuthLayout brand={<BrandWordmark />}>
      <h1 className="font-heading text-3xl">Vytvořit účet</h1>
    </AuthLayout>
  )
}
